<template>
    <kt-form-section is_first>
        <form id="customer_detail">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="text-align: right">
                <div class="section-header">
                    {{ $t('label.user-info') }}
                </div>
                <kt-row>
                    <kt-col v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL" lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="company_code">
                                {{ $t('label.national_legal_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="company_code"
                                    name="company_code"
                                    :disabled="!$can('manage','pos')"
                                    v-model="form_data.customer_detail.company_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL"
                                           for="national_code">
                                {{ $t('pos.ceo_national_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-label v-else for="national_code">
                                {{ $t('pos.national_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="national_code"
                                    name="national_code"
                                    :disabled="!$can('manage','pos') && form_data.customer_detail.customer_type_id == customerType.REAL"
                                    v-model="form_data.customer_detail.national_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="!is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_number">
                                {{ $t('label.birth_crtfct_number') }}<span
                                    v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="birth_crtfct_number"
                                    name="birth_crtfct_number"
                                    v-model="form_data.customer_detail.birth_crtfct_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="!is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_serial">
                                {{ $t('label.birth_crtfct_serial') }}<span
                                    v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="birth_crtfct_serial"
                                    name="birth_crtfct_serial"
                                    v-model="form_data.customer_detail.birth_crtfct_serial"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="!is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_series_number">
                                {{ $t('label.birth_crtfct_series_number') }}<span
                                    v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="birth_crtfct_series_number"
                                    name="birth_crtfct_series_number"
                                    v-model="form_data.customer_detail.birth_crtfct_series_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="!is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_number">
                                {{ $t('label.birth_crtfct_series_letter') }}<span
                                    v-if="form_data.customer_detail.customer_type_id == customerType.REAL"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="birth_crtfct_series_letter"
                                    name="birth_crtfct_series_letter"
                                    v-model="form_data.customer_detail.birth_crtfct_series_letter"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-bind:key="birthCrtfctSeriesLetter.key"
                                        v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                        :value="birthCrtfctSeriesLetter.key"
                                >
                                    {{ birthCrtfctSeriesLetter.value }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_date">
                                {{ $t('label.birth_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="birth_date"
                                    name="birth_date"
                                    v-model="form_data.customer_detail.birth_date" type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp=='NOVIN'" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="customer_id">
                                {{ $t('pos.customer_id') }}
                            </kt-form-label>
                            <kt-form-control
                                    disabled
                                    dir="ltr"
                                    id="customer_id"
                                    name="customer_id"
                                    v-model="form_data.customer_detail.customer_id"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.customer_type_id == customerType.LEGAL" lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="com_name_fa">
                                {{ $t('label.com_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="com_name_fa"
                                    name="com_name_fa"
                                    v-model="form_data.customer_detail.com_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.customer_type_id == customerType.REAL ||
                        form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                            lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="gender_id">
                                {{ $t('label.gender') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="gender_id"
                                    name="gender_id"
                                    v-model="form_data.customer_detail.gender_id"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-for="(item,index) in constants.gender" v-bind:key="index" :value="index">
                                    {{ item }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="mobile">
                                {{ $t('pos.mobile') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>

                            <kt-form-control
                                    dir="ltr"
                                    id="mobile"
                                    name="mobile"
                                    :disabled="!can_change"
                                    v-model="form_data.customer_detail.mobile"
                                    class="form-control"
                            ></kt-form-control>
                            <kt-form-label style="margin-top: 5px;font-size: 9px;color: red">
                                {{ $t('pos.mobile_notification') }}
                            </kt-form-label>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="first_name_fa">
                                {{ $t('label.first_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="first_name_fa"
                                    name="first_name_fa"
                                    v-model="form_data.customer_detail.first_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="last_name_fa">
                                {{ $t('label.last_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="last_name_fa"
                                    name="last_name_fa"
                                    v-model="form_data.customer_detail.last_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="father_name_fa">
                                {{ $t('label.father_name_fa') }}<span
                                    v-show="form_data.customer_detail.customer_type_id == customerType.REAL  ||
                                     form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="father_name_fa"
                                    name="father_name_fa"
                                    v-model="form_data.customer_detail.father_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="first_name_en">
                                {{ $t('label.first_name_en') }}<span
                                    v-show="form_data.customer_detail.customer_type_id == customerType.REAL||
                                       form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="first_name_en"
                                    name="first_name_en"
                                    v-model="form_data.customer_detail.first_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="last_name_en">
                                {{ $t('label.last_name_en') }}<span
                                    v-show="form_data.customer_detail.customer_type_id == customerType.REAL||
                                       form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="last_name_en"
                                    name="last_name_en"
                                    v-model="form_data.customer_detail.last_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="father_name_en">
                                {{ $t('label.father_name_en') }}<span
                                    v-show="form_data.customer_detail.customer_type_id == customerType.REAL||
                                       form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                    style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="father_name_en"
                                    name="father_name_en"
                                    v-model="form_data.customer_detail.father_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.customer_type_id == customerType.LEGAL" lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="register_date">
                                {{ $t('label.com_register_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="register_date"
                                    name="register_date"
                                    v-model="form_data.customer_detail.register_date" type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.customer_type_id == customerType.LEGAL" lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="company_register_number">
                                {{ $t('pos.com_register_no') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="company_register_number"
                                    name="company_register_number"
                                    v-model="form_data.customer_detail.company_register_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.customer_type_id == customerType.LEGAL" lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="com_name_en"><span style="color: red">{{ ' *' }}</span>
                                {{ $t('label.com_name_en') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="com_name_en"
                                    name="com_name_en"
                                    v-model="form_data.customer_detail.com_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="country">
                                {{ $t('label.country_flag') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="country"
                                    name="country"
                                    v-model="form_data.customer_detail.country"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-for="country in constants.country" v-bind:key="country.CountryCode"
                                        :value="country.CountryCode">
                                    {{ country.CountryName }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="foreign_pervasive_code">
                                {{ $t('pos.foreign_pervasive_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="foreign_pervasive_code"
                                    name="foreign_pervasive_code"
                                    v-model="form_data.customer_detail.foreign_pervasive_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="passport_number">
                                {{ $t('pos.passport_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="passport_number"
                                    name="passport_number"
                                    type="number"
                                    dir="ltr"
                                    v-model="form_data.customer_detail.passport_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="passport_expire_date">
                                {{ $t('pos.passport_credit_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="passport_expire_date"
                                    name="passport_expire_date"
                                    v-model="form_data.customer_detail.passport_expire_date" type="date"/>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>

                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input"
                                   id="is_foreign_nationals"
                                   name="is_foreign_nationals"
                                   v-model="is_foreign"
                            >
                            <label class="custom-control-label"
                                   for="is_foreign_nationals">{{ $t('pos.is_foreign') }}</label>
                        </div>
                    </kt-form-group>

                </kt-col>
                <kt-row v-if="$can('manage','pos') && !form_data.customer_detail.customer_id && psp=='NOVIN'">
                    <kt-col xl="10" lg="9" md="8" xs="7"></kt-col>
                    <kt-col xl="2" lg="3" md="4" xs="5">
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    @click="registerPosMerchant('register')"
                                    variant="success"
                                    type="button"
                                    v-bind:wide="true"
                                    id="register_merchant"
                            >
                                {{ $t('pos.register_in_psp') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
                <kt-row v-if="$can('manage','pos') && form_data.customer_detail.customer_id && psp=='NOVIN'">
                    <kt-col xl="10" lg="9" md="8" xs="7"></kt-col>
                    <kt-col xl="2" lg="3" md="4" xs="5">
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    @click="registerPosMerchant('update')"
                                    variant="success"
                                    v-bind:wide="true"
                                    id="update_merchant"
                            >
                                {{ $t('pos.update_in_psp') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
            </div>
        </form>
        <kt-row>
            <kt-col xl="10" lg="9" md="8" xs="7"></kt-col>
            <kt-col xl="2" lg="3" md="4" xs="5">
                <kt-form-action class="mt-4">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="next_step"
                            variant="success"
                            v-bind:wide="true"
                            id="next_step"
                    >
                        {{ $t('label.next_step') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </kt-form-section>
</template>

<script>
import {KTApp} from '@/plugins/core/app';
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import {mapGetters} from "vuex";
import {customerType} from '@/constants/posNovin'
import {posService} from '@/common/api.service'
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter';
import {lastIndexOf} from "lodash";

export default {
    data() {
        return {
            is_foreign: this.form_data.customer_detail.is_foreign_nationals,
            customerType,
            birthCrtfctSeriesLetters
        }
    },
    props: {
        form_data: {
            type: Object
        },
        wizard: {
            type: Object
        }
    },
    methods: {
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 500);

            setTimeout(() => {
                document.getElementById('mobile') && Inputmask('09999999999')
                        .mask(document.getElementById('mobile'))
            }, 500)
        },
        next_step() {
            let form = $('#customer_detail')
            form.validate({
                lang: 'fa',
                rules: {
                    birth_crtfct_number: {
                        required: () => {
                            if (!this.is_foreign && this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    birth_crtfct_serial: {
                        required: () => {
                            if (!this.is_foreign && this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    birth_crtfct_series_letter: {
                        required: () => {
                            if (!this.is_foreign && this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    birth_crtfct_series_number: {
                        required: () => {
                            if (!this.is_foreign && this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    birth_date: {
                        required: true,
                    },

                    is_foreign_nationals: {},

                    register_date: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    passport_expire_date: {
                        required: () => {
                            if (this.is_foreign) return true; else return false
                        }
                    },

                    com_name_fa: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    company_register_number: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    com_name_en: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    gender_id: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    last_name_fa: {
                        required: true
                    },

                    father_name_fa: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    first_name_fa: {
                        required: true
                    },
                    first_name_en: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },

                    last_name_en: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },
                    father_name_en: {
                        required: () => {
                            if (this.form_data.customer_detail.customer_type_id == customerType.REAL ||
                                    this.form_data.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        }
                    },

                    foreign_pervasive_code: {
                        required: () => {
                            if (this.is_foreign) return true; else return false
                        }
                    },
                    passport_number: {
                        required: () => {
                            if (this.is_foreign) return true; else return false
                        }
                    },
                    country: {
                        required: () => {
                            if (this.is_foreign) return true; else return false
                        }
                    },
                    mobile: {
                        required: true,
                        digits: 11
                    },

                    national_code: {
                        required: true,
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            if (!this.checkIfIsPersian(this.form_data.customer_detail.com_name_fa)) {
                form.validate().showErrors({
                    com_name_fa: i18n.t('pos.validations.enter_persian')
                })
                return;
            }
            if (!this.checkIfIsPersian(this.form_data.customer_detail.last_name_fa)) {
                form.validate().showErrors({
                    last_name_fa: i18n.t('pos.validations.enter_persian')
                })
                return;
            }
            if (!this.checkIfIsPersian(this.form_data.customer_detail.father_name_fa)) {
                form.validate().showErrors({
                    father_name_fa: i18n.t('pos.validations.enter_persian')
                })
                return;
            }
            if (!this.checkIfIsPersian(this.form_data.customer_detail.first_name_fa)) {
                form.validate().showErrors({
                    first_name_fa: i18n.t('pos.validations.enter_persian')
                })
                return;
            }
            if (!this.checkIfIsEnglish(this.form_data.customer_detail.com_name_en)) {
                form.validate().showErrors({
                    com_name_en: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            if (!this.checkIfIsEnglish(this.form_data.customer_detail.last_name_en)) {
                form.validate().showErrors({
                    last_name_en: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            if (!this.checkIfIsEnglish(this.form_data.customer_detail.father_name_en)) {
                form.validate().showErrors({
                    father_name_en: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            if (!this.checkIfIsEnglish(this.form_data.customer_detail.first_name_en)) {
                form.validate().showErrors({
                    first_name_en: i18n.t('pos.validations.enter_english')
                })
                return;
            }

            this.form_data.customer_detail.is_foreign_nationals = this.is_foreign
            this.wizard.current_step = 2;
        },
        registerPosMerchant(method) {
            if (method == 'register') {
                let param = {
                    pos_merchant_id: this.form_data.pos_merchant_id
                }
                let btn = $('#register_merchant')
                KTApp.progress(btn)
                posService.addNewCustomer(param, this.$store.state.pos.psp).then(response => {
                    this.form_data.customer_detail.customer_id = response.data.data
                    return this.toastr.success(response.data.message)
                }).catch(({response}) => {
                    return this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })

            } else if (method == 'update') {
                let btn = $('#update_merchant')

            }

        },
        checkIfIsPersian(value) {
            if (!value || value=='null') return true;

            let regex = /^[\u0600-\u06FF\s]+$/;

            return regex.test(value)
        },
        checkIfIsEnglish(value) {
            if (!value || value =='null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*| ']*$/;

            return regex.test(value)
        },
    },
    mounted() {
        this.afterDispatch()
        if (window.localStorage.getItem('go') === '2') {
            window.localStorage.setItem('go', 'change');
            this.wizard.current_step = 2;
        }
    },
    computed: {
        ...mapGetters('pos', [
            'constants', 'can_change', 'psp'
        ])
    }
}
</script>

<style>
</style>